<!--
 * @Description: 重置密码
 * @Date: 2021-11-10 13:44:01
-->
<template>
  <div class="user-login__item user-login__reset">
    <div class="user-login__sec">重置密码</div>
    <LoginForm
      ref="formRef"
      :itemList="[FormItemEnum.pwd, FormItemEnum.pwd2, FormItemEnum.agreement]"
      :formData="formData"
      :pageType="LoginTypeEnum.RESET"
    ></LoginForm>
    <div class="user-login__reset-foot">
      <base-button @click="onCancel" type="default">上一步</base-button>
      <base-button :click="onLogin">提交</base-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { BaseButton } from 'xrk-components';

import { LoginForm } from './login-base/index';
import type { FormRef, FormData } from '../types/index';
import { LoginTypeEnum, FormItemEnum } from '../constants/index';

import { setAPassword } from '../data-source/apis';
import { useSetup } from '../store';

const model = defineModel();

const store = useSetup();
// 表单实例
const formRef = ref<FormRef>(null);
const formData = ref<FormData>({
  [FormItemEnum.agreement]: store.loginData.agreement
});

const onCancel = () => {
  model.value = 'login-forget';
  store.setLoginData({
    [FormItemEnum.agreement]: formRef.value.data[FormItemEnum.agreement]
  });
};
const onLogin = async () => {
  await formRef.value.validate();
  await setAPassword({
    [FormItemEnum.pwd]: formRef.value.data[FormItemEnum.pwd],
    [FormItemEnum.pwd2]: formRef.value.data[FormItemEnum.pwd2],
    authentication: store.info.authentication
  });
  store.login();
  model.value = 'login-success';
};
</script>

<style scoped lang="scss">
.user-login__reset {
  .user-login__reset-foot {
    display: flex;
    align-items: center;
    justify-content: space-between;
    button {
      width: 167px;
      height: 44px;
    }
  }
}
</style>
